import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VProgressLinear,{attrs:{"indeterminate":"","color":"blue darken-2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }